import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";
import CgnButtonDropdown from "../toolbox/CgnButtonDropdown";
import CgnBadge from "../toolbox/CgnBadge";

class MachineCustomer2List extends Component {
  state = {
    pageTitle: "Makine Müşteri Listele",
    pageAddLink: "makine-musteri-2-ekle",
    pageUpdateLink: "makine-musteri-2-guncelle",
    pageDetailLink: "makine-musteri-detay",
    pageListLink: "makine-musteri-listele",
    breadcrumb: [{ text: "Makine Müşteri", link: "#" }],
    isLoading: false,
    isDeleted: false,
    status: false,
    machineCustomer2Data: [],
    machineName: "",
    customerName: "",
    saleTypeName: "",
    brandName: "",
    modelName: "",
    machineSerialNo: "",
    guid: "",
    alertErrorMessage: "",
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var statusType = 1; // 1 aktif ve pasiflerin ikisinide getirmesi için
    axios
      .get(URL + "/machineCustomer2/getlist/" + statusType, config)
      .then((response) => {
        this.setState({
          machineCustomer2Data: response.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  handleDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.deleteItem(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };

  async deleteItem(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/machineCustomer2/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        confirmAlert({
          title: CgnMessage.alertSuccessTitle,
          message: CgnMessage.deleteSuccessMessage,
          buttons: [
            {
              label: CgnMessage.closeButton,
              onClick: () => {
                window.location.reload();
              }
            },
          ],
        });
      })
      .catch((error) => {
        confirmAlert({
          title: CgnMessage.alertErrorTitle,
          message: error.response.data,
          buttons: [
            {
              label: CgnMessage.closeButton,
              onClick: () => {
                this.setState({
                  isLoading: false,
                });
              }
            },
          ],
        });
      });
  }
  thStyle = {
    width: "120px",
  };

  thStyle2 = {
    width: "120px",
  };

  tdStyle = {
    width: "400px",
  };

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row className="machineCustomer2List" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              <CgnDatatable
                data={this.state.machineCustomer2Data}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Makine Müşteri Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      return (
                        <Table className="table table-responsive ">
                          <tbody>
                            <tr>
                              <th style={this.thStyle}>Makine</th>
                              {/* <th className="colon">:</th> */}
                              <td style={this.tdStyle}>
                                {row.machineSerialNo &&
                                  row.machineName &&
                                  row.machineSerialNo + " / " + row.machineName}
                                {!row.machineSerialNo &&
                                  row.machineName &&
                                  row.machineName}
                              </td>
                              <th style={this.thStyle2}>Başlangıç Tarihi</th>
                              {/* <th className="colon">:</th> */}
                              <td>{row.entryDate}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Müşteri</th>
                              {/* <th className="colon">:</th> */}
                              <td style={this.tdStyle}>
                                {row.customerName ? row.customerName : "-"}
                              </td>
                              <th style={this.thStyle2}>Bitiş Tarihi</th>
                              {/* <th className="colon">:</th> */}
                              <td>{row.endDate ? row.endDate : "-"}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Satış Türü</th>
                              {/* <th className="colon">:</th> */}
                              <td colSpan={5}>
                                {row.saleTypeName ? row.saleTypeName : "-"}
                              </td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Ekleyen Kullanıcı</th>
                              <td colSpan={4}>{row.createdBy}</td>
                            </tr>
                          </tbody>
                        </Table>
                      );
                    },
                  },
                  {
                    selector: "status",
                    width: "110px",
                    padding: "0px",
                    sortable: false,
                    cell: (row) => {
                      if (row.status) {
                        return <CgnBadge color="success" text="Aktif" />;
                      } else {
                        return <CgnBadge color="danger " text="Pasif" />;
                      }
                    },
                  },
                  {
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, cell) => (
                      <CgnButtonDropdown
                        label={"Yönet"}
                        className="mr-0"
                        color="primary"
                        items={[
                          {
                            text: CgnMessage.updateButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageUpdateLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.detailButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageDetailLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.deleteButton,
                            className: "dropDownBtn",
                            onClick: () => this.handleDelete(row.guid),
                          },
                        ]}
                      />
                    ),
                  },
                ]}
                loading={this.state.isLoading}
              />
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default MachineCustomer2List;
